import React, {FunctionComponent, useEffect, useRef, useState} from "react";
import {RootState} from "../../../../Config/Store";
import {useAppDispatch, useAppSelector} from "../../../../Config/Hooks";
import {Equipment, getEntity, reset, TeleObject, TeleObjectType} from "./EquipmentDetailsSkidReducer";
import {Button, Divider, Grid, Typography} from "@mui/material";
import {ArrowForward} from "@mui/icons-material";
import {truncateNumber} from "../../../../Utils/NumberUtil";
import {TeleObjectDTO, EquipmentDetailsReactQuery} from "./EquipmentDeatilsQuery";
import TeleObjectChart from "./TeleObjectChart";
import DataNotFound from "../../../../Shared/Components/DataNotFoundMessage";
import {HeaderMenu} from "./HeaderMenu";
import ActiveAlarms from "../../Powerplant/ActiveAlarms/ActiveAlarms";
import {format} from "date-fns";
import {ACard, Period, Skeleton, ADataGrid, ADataGridColors} from "@atiautomacao/ati-ui-library";
import {DateFormat, LocalDateTimeFormatISO} from "../../../../Utils/DateFormatPatternUtils";
import Tooltip from "@mui/material/Tooltip";
import {telecommandColumns, telemetryColumns, telesinalColumns} from "./ColumnsCustom";
import {hasPermission} from "../../../../Shared/Auth/AuthenticationUtil";
import {AUTHORITIES} from "../../../../Config/Constants";
import {CommandDTO, ModalForSendingTelecommand} from "../../../../Shared/Components/ModalForSendingTelecommand";
import Box from "@mui/material/Box";

import "./index.css";
import axios from "axios";
import {useSnackbar} from "notistack";
import { MenuItemStatus } from "../../../../Shared/Components/Layout/menu/types/MenuItemStatus";
import { CSSProperties } from "styled-components";
import {getStatusName} from "../../../../Shared/Components/Layout/menu/helpers/getStatusName";
import {formatInhibitedStatus, getEquipmentTeleObjectColors} from "../../../../Utils/InhibitionVisual";


export interface DetailsRow {
    id: number;
    selected?: boolean;
    teleObjectName: string;
    inhibited: boolean;
    operationalStatus?: string;
    status?: string;
    telemetryStatus?: string;
    value?: number | string;
    userId?: number;
    teleObjectSpecType?: number;
    point?: number;
    etsCode?: number;
    brokerId?: number;
    confirmation?: boolean;
    actionsConfig?: any;
}

export interface TeleObjectData {
    id?: number;
    name: string;
    data: number[],
    time: string[],
    teleObjectType: string;
    unit?: string;
    periodType?: string;
}

const initialPeriod: Period = {
    groupBy: "week",
    fromDateTime: new Date(new Date().setDate(new Date().getDate() - 3)),
    toDateTime: new Date()
};

interface TeleObjectInfo {
    id: number;
    name: string;
}

const stylesToCircle:CSSProperties = {
    borderRadius: '50%',
    display: 'inline-block',
    padding: 5,
    marginLeft: 5,
    boxShadow: "2px 2px 2px rgba(0, 0, 0, 0.24)",
    alignItems: "flex-start",
    alignContent: "center",
    
}

const EquipmentDetailsSkid: FunctionComponent<{ equipmentId: number, status: MenuItemStatus }> = ({equipmentId, status}) => {
    const dispatch = useAppDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const account = useAppSelector(state => state.authentication.account);
    const isAuthorizedToSendCommand = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.SEND_POWER_STATION_EQUIPMENT_DETAIL_COMMAND, AUTHORITIES.SEND_SKID_EQUIPMENT_DETAIL_COMMAND
    ]);
    const openSubMenu = useAppSelector((state: any) => state.layout.openSubMenu);
    const loading = useAppSelector((state: RootState) => state.equipmentDetailsSkid.loading);
    const selectedPowerPlant = useAppSelector((state: RootState) => state.dashboard.selectedPowerPlant);
    const [teleObjectDTO, setTeleObjectDTO] = useState<TeleObjectDTO | null>()
    const [entity, setEntity] = useState<TeleObjectType | null>(null)
    const {data, isSuccess, error} = EquipmentDetailsReactQuery(teleObjectDTO);
    const [telemetryRows, setTelemetryRows] = useState<Array<DetailsRow>>([]);
    const [telecommandRows, setTelecommandRows] = useState<Array<DetailsRow>>([]);
    const [telesinalRows, setTelesinalRows] = useState<Array<DetailsRow>>([]);
    // Resultado dos gráficos ALINHADO por índice ao teleObjectIDs (null = sem dado / erro).
    // Substitui a lista achatada + `% length`, que reaproveitava dados de outro teleobjeto (SGD-3236).
    const [chartDataList, setChartDataList] = useState<(TeleObjectData | null)[]>([])
    const [telemetryIDs, setTelemetryIDs] = useState<TeleObjectInfo[]>([]);
    const [telecommandIDs, setTelecommandIDs] = useState<TeleObjectInfo[]>([]);
    const [telesinalIDs, setTelesinalIDs] = useState<TeleObjectInfo[]>([]);
    const [teleObjectIDs, setTeleObjectIDs] = useState<TeleObjectInfo[]>([]);
    const [period, setPeriod] = useState<Period>(initialPeriod);
    const [actualIndex, setActualIndex] = useState<number>(-1)
    const [generateChart, setGenerateChart] = useState<boolean>(false)
    const [loadingStates, setLoadingStates] = useState<boolean[]>([])
    // Conta teleobjetos sem dados (204/404) na geração atual, pra consolidar num ÚNICO toast ao fim. SGD-3236.
    const noDataCountRef = useRef(0)
    const [isClear, setIsClear] = useState(false);
    const [open, setOpen] = useState(false);
    const [content, setContent] = useState<JSX.Element[]>();
    const [selectedCommandRow, setSelectedCommandRow] = useState<DetailsRow | null>(null);
    const [commandDTO, setCommandDTO] = useState<CommandDTO>();
    const [equipmentToShow, setEquipmentToShow] = useState<Equipment | undefined>(undefined);
    const [commandValueList, setCommandValueList] = useState<Array<any>>([])
    useEffect(() => {
        let isActive = true;
        setEntity(null)
        setEquipmentToShow(undefined)
        setTelemetryRows([])
        setTelesinalRows([])
        setTelecommandRows([])
        setChartDataList([])
        setLoadingStates([])
        setContent(undefined)
        setGenerateChart(false)
        setActualIndex(-1)
        setTelecommandIDs([])
        setTelesinalIDs([])
        setTelemetryIDs([])
        setTeleObjectIDs([])
        setTeleObjectDTO(null)
        setIsClear(true)
        setOpen(false)
        setSelectedCommandRow(null)
        setCommandDTO(undefined)
        setCommandValueList([])
        noDataCountRef.current = 0
        dispatch(reset());
        const request = dispatch(getEntity(equipmentId));
        request
            .then((response) => {
                if (!isActive) {
                    return;
                }
                const payload = response?.payload?.data?.data;
                if (payload) {
                    setEntity({
                        ...payload,
                        telesinalList: payload.telesinalList ?? [],
                        telemetryList: payload.telemetryList ?? [],
                        telecommandList: payload.telecommandList ?? [],
                    });
                } else {
                    setEntity(null)
                }
            }).catch((error) => {
                if (!isActive) {
                    return;
                }
                console.log(error)
            })
        return () => {
            isActive = false;
            request.abort();
        };
    }, [equipmentId])

    const ajustDate = (dateList: string[]) => {
        return dateList.map((date) => {
            return format(new Date(date), 'yyyy-MM-dd HH:mm:ss.S')
        })

    }

    const validateValue = (value: number, unit: string) => {
        const decimalPlaces = 2;

        if (value !== null && unit) {
            return `${truncateNumber(value, decimalPlaces)} ${unit}`;
        } else if (value !== null) {
            return truncateNumber(value, decimalPlaces).toString();
        } else if (unit) {
            return '-';
        } else {
            return '-';
        }
    };
    const orderByAlarmed = (details: DetailsRow[]) => {
        if(details !== undefined && details.length > 0){
            details.sort((a, b) => {
                if (a.inhibited && !b.inhibited) return -1;
                if (!a.inhibited && b.inhibited) return 1;
                if (a.operationalStatus?.toLowerCase() === "alarmado" && b.operationalStatus?.toLowerCase() !== "alarmado") return -1;
                if (a.operationalStatus?.toLowerCase() !== "alarmado" && b.operationalStatus?.toLowerCase() === "alarmado") return 1;
                return a.teleObjectName.localeCompare(b.teleObjectName);
            });
        }
    }
    const structureMetryRow = (entitiesValues: Array<TeleObject>) => {
        let details: Array<DetailsRow> = []
        entitiesValues.forEach(detail => {
            details.push({
                id: detail.id,
                selected: false,
                teleObjectName: detail.name,
                inhibited: detail.inhibited === true,
                operationalStatus: detail.status,
                value: validateValue(detail.value, detail.unit),
                status: formatInhibitedStatus(detail.inhibited, detail.status)
            });
        });
        if(details.length > 0) orderByAlarmed(details)
        return details;
    }

    const structureCommandRow = (entitiesValues: Array<TeleObject>) => {
        let details: Array<DetailsRow> = []
        entitiesValues.forEach(detail => {
            details.push({
                id: detail.id,
                selected: false,
                teleObjectName: detail.name,
                inhibited: detail.inhibited === true,
                operationalStatus: detail.status,
                userId: detail.userId,
                teleObjectSpecType: detail.teleObjectTypeId,
                point: detail.point,
                etsCode: detail.etsCode,
                brokerId: detail.brokerId,
                value: validateValue(detail.value, detail.unit),
                status: formatInhibitedStatus(detail.inhibited, detail.status),
                actionsConfig: [
                    {actionName: "send", disabled: !isAuthorizedToSendCommand},
                ]
            });
        });
        if(details.length > 0) orderByAlarmed(details)
        return details;
    }
    const structureTelesinalRow = (entitiesValues: Array<TeleObject>) => {
        let details: Array<DetailsRow> = []
        entitiesValues.forEach(detail => {
            details.push({
                id: detail.id,
                selected: false,
                teleObjectName: detail.name,
                inhibited: detail.inhibited === true,
                operationalStatus: detail.status,
                status: formatInhibitedStatus(detail.inhibited, detail.status)
            });
        });
        if(details.length > 0) orderByAlarmed(details)
        return details;
    }

    useEffect(() => {
        if (entity) {
            setIsClear(false)
            setTelemetryRows(structureMetryRow(entity.telemetryList ?? []));
            setTelecommandRows(structureCommandRow(entity.telecommandList ?? []));
            setTelesinalRows(structureTelesinalRow(entity.telesinalList ?? []));
            if (entity.equipment) {
                setEquipmentToShow({
                    name: entity.equipment.name,
                    lastDateTime: entity.equipment.lastDateTime,
                    status: "Mudar",
                    equipmentClass: entity.equipment.equipmentClass?.name,
                    skid: entity.equipment.skid,
                    description: entity.equipment?.description,
                    utrIpAddress: entity.equipment?.utrIpAddress,
                    seriesNumber: entity.equipment?.seriesNumber,
                    abbreviation: entity.equipment?.abbreviation
                })
            } else {
                setEquipmentToShow(undefined)
            }

        }else{
            setTelecommandRows([])
            setTelesinalRows([])
            setTelemetryRows([])
            setEquipmentToShow(undefined)
        }
    }, [entity]);

    const handlePeriodChange = (newPeriod: Period) => {
        setPeriod(newPeriod);
    };
    useEffect(() => {
        setTeleObjectIDs([...telemetryIDs, ...telesinalIDs, ...telecommandIDs])
    }, [telemetryIDs, telesinalIDs, telecommandIDs]);

    const insertCharts = () => {
        if(period != null && teleObjectIDs.length > 0) {
            noDataCountRef.current = 0
            setLoadingStates(teleObjectIDs.map(() => true))
            setChartDataList(teleObjectIDs.map(() => null))
            setContent(undefined)
            setGenerateChart(true)
            setActualIndex(0)
        }
    }
    useEffect(() => {
        if(generateChart && actualIndex >= 0 && actualIndex < teleObjectIDs.length){
            if(period.toDateTime != null && period.fromDateTime != null){
                setTeleObjectDTO({
                    startDateTime: LocalDateTimeFormatISO(period.fromDateTime),
                    stopDateTime: LocalDateTimeFormatISO(period.toDateTime),
                    equipmentId: equipmentId,
                    teleObjectList: [teleObjectIDs[actualIndex].id]
                })
            }
        }
        if(actualIndex >= teleObjectIDs.length){
            setGenerateChart(false)
            setTeleObjectDTO(null)
            // Fim do loop: se um ou mais teleobjetos ficaram sem dados, mostra UM único toast. SGD-3236.
            if(noDataCountRef.current > 0){
                enqueueSnackbar('Não foi possível encontrar dados para o período selecionado. Tente mudar o Range de datas!', {variant: 'warning'});
                noDataCountRef.current = 0
            }
        }
    }, [actualIndex]);

    useEffect(() => {
        if(isSuccess){
            const indexBeingFetched = actualIndex;
            setActualIndex(prev => prev + 1)

            // Cada requisição traz os dados de UM teleobjeto. Guardamos o resultado ALINHADO ao
            // índice do teleobjeto (não numa lista achatada), pra cada gráfico ficar amarrado ao
            // seu próprio teleobjeto e não reaproveitar/duplicar dado de outro. SGD-3236.
            let teleData: TeleObjectData | null = null
            if(data?.data?.telecommandList != null && data?.data?.telecommandList.length > 0){
                const item = data.data.telecommandList[0]
                teleData = {
                    id: item.id,
                    name: item.name,
                    data: item.value.map(value => truncateNumber(value, 2)),
                    time: ajustDate(item.time),
                    teleObjectType: 'TELECOMANDO',
                    unit: item.unit,
                    periodType: period ? period.groupBy : ""
                }
            } else if(data?.data?.telemetryList != null && data?.data?.telemetryList.length > 0){
                const item = data.data.telemetryList[0]
                teleData = {
                    id: item.id,
                    name: item.name,
                    data: item.value.map(value => truncateNumber(value, 2)),
                    time: ajustDate(item.time),
                    teleObjectType: 'TELEMEDIDA',
                    unit: item.unit,
                    periodType: period ? period.groupBy : ""
                }
            } else if(data?.data?.telesinalList != null && data?.data?.telesinalList.length > 0){
                const item = data.data.telesinalList[0]
                teleData = {
                    id: item.id,
                    name: item.name,
                    data: item.value.map(value => truncateNumber(value, 2)),
                    time: ajustDate(item.time),
                    teleObjectType: 'TELESINAL',
                    periodType: period ? period.groupBy : ""
                }
            }

            if(teleData != null){
                const resolved = teleData;
                setChartDataList(prev => {
                    const next = [...prev];
                    next[indexBeingFetched] = resolved;
                    return next;
                })
            } else {
                // Req 2xx (204/sem conteúdo): cai no sucesso, mas sem dados no período.
                // Só contamos aqui; o toast é consolidado num único aviso ao fim do loop. SGD-3236.
                noDataCountRef.current += 1
            }
            setLoadingStates(prevState => prevState.map((loading,index) =>
                index === indexBeingFetched ? false : loading
            ))
        }
    }, [data]);

    useEffect(() => {
        if(error){
            setLoadingStates(prevState => prevState.map((loading,index) =>
                index === actualIndex ? false : loading
            ))
            setActualIndex(prev => prev + 1);
            // @ts-ignore
            const status = error?.response?.status
            if (status === 400) {
                // @ts-ignore
                const valueMaxLimit = (error.response?.data?.detail?.match(/\d+/g) || []).join("");
                // @ts-ignore
                const detailsMessage = error.response?.data?.detail;
                if(detailsMessage.includes("Selected period exceeds the limit of")){
                    enqueueSnackbar(`Período selecionado ultrapassa o limite de ${valueMaxLimit.length > 0 ? + valueMaxLimit : ""}
                        registros.`, {variant: 'error'});
                }
            } else if(status === 404) {
                // Sem dados (404): conta pro toast consolidado do fim do loop. SGD-3236.
                noDataCountRef.current += 1
            }
        }
    }, [error]);

    const handleColor = (data: any): ADataGridColors => {
        return getEquipmentTeleObjectColors(data);
    }

    const handleOnTelecommandRow = (rows:any) => {
        const telecommandInfo:TeleObjectInfo[] = rows.filter((row:any) => row.selected === true).map((row:any) => {
            return {
                id: row.id,
                name: row.name
            }
        })
        setTelecommandIDs(telecommandInfo)
    }

    useEffect(() => {
        if(selectedCommandRow != null){
            if(selectedCommandRow.userId != null &&
                selectedCommandRow.point != null &&
                selectedCommandRow.teleObjectSpecType != null &&
                selectedCommandRow.etsCode &&
                selectedCommandRow.brokerId){
                setCommandDTO({
                    id: selectedCommandRow.id,
                    teleObjectName: selectedCommandRow.teleObjectName,
                    userId: selectedCommandRow.userId,
                    point: selectedCommandRow.point,
                    teleObjectSpecType: selectedCommandRow.teleObjectSpecType,
                    etsCode: selectedCommandRow.etsCode,
                    brokerId: selectedCommandRow.brokerId,
                    commandValues: commandValueList,
                    confirmation: selectedCommandRow.confirmation ?? true
                })
            }

        }
    }, [selectedCommandRow]);

    const handleOnTelesinalRow = (rows:any) => {
        const telesinalsInfo:TeleObjectInfo[] = rows.filter((row:any) => row.selected === true).map((row:any) => {
            return {
                id: row.id,
                name: row.name
            }
        })
        setTelesinalIDs(telesinalsInfo)
    }

    const handleOnTelemetryRow = (rows:any) => {
        const telemetryInfo:TeleObjectInfo[] = rows.filter((row:any) => row.selected === true).map((row:any) => {
            return {
                id: row.id,
                name: row.name
            }
        })
        setTelemetryIDs(telemetryInfo)
    }

    const handleCommandRow = async (row: any) => {
        try{
            await axios.get(`/api/command-value/tele-object/${row?.id}`).then(
                response => {
                    setCommandValueList(response.data.data)
                }
            )
        }catch (error){
            enqueueSnackbar("Erro ao buscar lista de valores de comando", { variant: 'error' });
        }
        setSelectedCommandRow(row)
        setOpen(true);
    }

    const handleCloseModal = () => {
        setOpen(false);
        setSelectedCommandRow(null);
    };
    // Monta um slot POR teleobjeto selecionado, alinhado por índice: carregando → skeleton;
    // com dado → gráfico; sem dado/erro → card "Não há dados disponíveis para exibição".
    // Sem `% length`, então nenhum teleobjeto reaproveita o dado de outro. SGD-3236.
    useEffect(() => {
        if (loadingStates.length > 0) {
            setContent(loadingStates.map((loading, index) => {
                const key = `chart-equipment-details-chart-${openSubMenu}-${index.valueOf()}`;
                if (loading) {
                    return (
                        <Grid key={key} item xs={12} sm={12} md={12}>
                            <ACard>
                                <Skeleton animation="wave" height={289} variant="rounded" width="100%" />
                            </ACard>
                        </Grid>
                    );
                }
                const teleObjectData = chartDataList[index];
                if (!teleObjectData) {
                    return (
                        <Grid key={key} item xs={12} sm={12} md={12}>
                            <ACard title={teleObjectIDs[index] ? teleObjectIDs[index].name : ""}>
                                <DataNotFound
                                    boxStyle={{height: 289, width: '100%'}}
                                    message={"Não há dados disponíveis para exibição"}
                                />
                            </ACard>
                        </Grid>
                    );
                }
                return (
                    <Grid key={key} item xs={12} sm={12} md={12}>
                        <TeleObjectChart teleObjectData={teleObjectData}/>
                    </Grid>
                );
            }));
        }
    }, [chartDataList, loadingStates, openSubMenu, teleObjectIDs]);

    const disableGraphicButton = () => {
        return telesinalIDs.length === 0 && telemetryIDs.length === 0 && telecommandIDs.length === 0;
    }
    // const isDataNotFound = (data:any, length:number) => {
    //     return
    // }
    // useEffect(() => {
    //     if(loading){
    //         setLoadingOrNotFound(
    //             <Skeleton animation="wave" height={289} variant="rounded" width="100%" />
    //         )
    //     }else if(){
    //
    //     }
    // }, [loading]);
    return (
        <>
            <HeaderMenu onClick={insertCharts} onPeriod={handlePeriodChange} disableButton={disableGraphicButton()}/>
            <Box aria-label={"equipment-details"} sx={{paddingTop: 10}}>
                <ACard title={'Equipamento'}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography
                                variant="h1"
                                gutterBottom
                                fontWeight={700} fontSize={18}
                                display={"flex"}
                            >
                                {equipmentToShow?.name}
                                {equipmentToShow?.skid?.name && (
                                    <>
                                        <Divider orientation="vertical" flexItem sx={{ borderRightWidth: "medium", borderColor: "#000", padding: 0.8 }} />

                                        <Typography
                                            variant="h2" fontSize={18} paddingLeft={1.2}
                                        >
                                            {equipmentToShow?.skid?.name}
                                        </Typography>
                                    </>
                                )}

                            </Typography>
                        </Grid>

                        <Grid item xs={12} lg={6} xl={4}>
                            <Typography
                                variant="h2" display={"flex"}
                                fontWeight={700} fontSize={16}
                            >
                                Status:

                                <Typography
                                    variant="h2" display={"flex"}
                                    fontSize={16}
                                    style={{ paddingLeft: 4 }}
                                >
                                    {status ? getStatusName(status) : "-"}
                                </Typography>


                            </Typography>

                        </Grid>

                        <Grid item xs={12} lg={6} xl={4}>
                            <Typography
                                variant="h2" display={"flex"}
                                fontWeight={700} fontSize={16}
                            >
                                Última Atualização:
                                <Typography
                                    variant="h2" display={"flex"}
                                    fontSize={16}
                                    style={{ paddingLeft: 4 }}
                                >
                                    {equipmentToShow?.lastDateTime ? DateFormat(equipmentToShow.lastDateTime) : "-"}
                                </Typography>
                            </Typography>

                        </Grid>

                        <Grid item xs={12} lg={6} xl={4} >
                            <Typography
                                variant="h2" display={"flex"}
                                fontWeight={700} fontSize={16}
                            >
                                Serie:
                                <Typography
                                    variant="h2" display={"flex"}
                                    fontSize={14}
                                    style={{ paddingLeft: 4 }}
                                >
                                    {equipmentToShow?.seriesNumber ? equipmentToShow.seriesNumber : " -"}
                                </Typography>

                            </Typography>

                        </Grid>


                        <Grid item xs={12} lg={6} xl={4}>
                            <Typography
                                variant="h2" display={"flex"}
                                fontWeight={700} fontSize={16}
                                style={{ alignItems: "center" }}
                            >
                                Classe de Equipamento:
                                <Typography
                                    variant="h2" display={"flex"}
                                    fontSize={16}
                                    style={{ alignItems: "center", paddingLeft: 4 }}
                                >
                                    {equipmentToShow?.equipmentClass ? equipmentToShow.equipmentClass : "-"}
                                </Typography>
                            </Typography>
                        </Grid>

                        <Grid item xs={12} lg={6} xl={4}>

                            <Typography
                                variant="h2" display={"flex"}
                                fontWeight={700} fontSize={16}
                                style={{ alignItems: "center" }}
                            >
                                Sigla:
                                <Typography
                                    variant="h2" display={"flex"}
                                    fontSize={16}
                                    style={{ alignItems: "center", paddingLeft: 4 }}
                                >
                                    {equipmentToShow?.abbreviation ? equipmentToShow.abbreviation : " -"}
                                </Typography>
                            </Typography>

                        </Grid>

                        <Grid item xs={12} lg={6} xl={4}>

                            <Typography
                                variant="h2" display={"flex"}
                                fontWeight={700} fontSize={16}
                                style={{ alignItems: "center" }}
                            >

                                Endereço IP:
                                <Typography
                                    variant="h2" display={"flex"}
                                    fontSize={16}
                                    style={{ alignItems: "center", paddingLeft: 4 }}
                                >
                                    {equipmentToShow?.utrIpAddress ? equipmentToShow.utrIpAddress : "-"}
                                </Typography>
                            </Typography>

                        </Grid>

                        <Grid item xs={12} lg={6} xl={4}>
                            <Typography
                                variant="h2" display={"flex"}
                                fontWeight={700} fontSize={16}
                                style={{ alignItems: "center" }}
                            >
                                Descrição:
                                <Typography
                                    variant="h2" display={"flex"}
                                    fontSize={16}
                                    style={{ alignItems: "center", paddingLeft: 4 }}
                                >
                                    {equipmentToShow?.description ? equipmentToShow.description : "-"}
                                </Typography>
                            </Typography>
                        </Grid>
                    </Grid>
                </ACard>
            </Box>
            <Grid
                key={`chart-equipment-details-${openSubMenu}`}
                container spacing={3} style={{ marginTop: '40px' }}
            >
                <Grid item xs={12} lg={6} xl={4}>
                    <ACard
                        title={'Estados'}>
                        {
                            loading ? (<Skeleton animation="wave" height={289} variant="rounded" width="100%" />)
                            : (telesinalRows != null && telesinalRows.length > 0 &&
                                    <ADataGrid
                                    ariaLabel={"details-states"}
                                    hideFilters={true}
                                    showFilterOptions={false}
                                    disablePagination={true}
                                    hideSelection={false}
                                    size={"small"}
                                    columns={telesinalColumns}
                                    rows={telesinalRows}
                                    onRowSelect={handleOnTelesinalRow}
                                    loading={false}
                                    totalOfRecords={telesinalRows.length ?? 0}
                                    rowsPerPage={telesinalRows.length ?? 0}
                                    onClearSelectedTempRows={isClear}
                                    onColorSelect={handleColor}
                                    maxHeight={400}
                                    /> || (
                                                <DataNotFound boxStyle={{height: 289, width: '100%'}}/>
                                        )
                               )
                        }

                    </ACard>
                </Grid>
                <Grid item xs={12} lg={6} xl={4}>
                    <ACard title={'Medidas'}>
                        {
                            loading ? (<Skeleton animation="wave" height={289} variant="rounded" width="100%" />)
                                : ( telemetryRows != null && telemetryRows.length > 0 &&
                                    <ADataGrid
                                        ariaLabel={"details-measure"}
                                        hideFilters={true}
                                        showFilterOptions={false}
                                        disablePagination={true}
                                        hideSelection={false}
                                        size={"small"}
                                        columns={telemetryColumns}
                                        rows={telemetryRows}
                                        //page={pagedSearchParams.page}
                                        onRowSelect={handleOnTelemetryRow}
                                        loading={false}
                                        totalOfRecords={telemetryRows.length ?? 0}
                                        onColorSelect={handleColor}
                                        rowsPerPage={telemetryRows.length ?? 0}
                                        maxHeight={400}
                                        onClearSelectedTempRows={isClear}
                                    /> || (
                                            <DataNotFound boxStyle={{height: 289, width: '100%'}}/>
                                        )
                                )
                        }
                    </ACard>
                </Grid>

                <Grid item xs={12} lg={6} xl={4}>
                    <ACard title={'Comandos'}>
                        {loading ? (<Skeleton animation="wave" height={289} variant="rounded" width="100%" />)
                         : ( telecommandRows != null && telecommandRows.length > 0 &&
                                <ADataGrid
                                    ariaLabel={"details-commands"}
                                    hideFilters={true}
                                    disablePagination={true}
                                    showFilterOptions={false}
                                    hideSelection={false}
                                    size={"small"}
                                    columns={telecommandColumns}
                                    rows={telecommandRows}
                                    //page={pagedSearchParams.page}
                                    onRowSelect={handleOnTelecommandRow}
                                    loading={false}
                                    totalOfRecords={telecommandRows.length ?? 0}
                                    rowsPerPage={telecommandRows.length ?? 0}
                                    actionColumnWidth={50}
                                    onClearSelectedTempRows={isClear}
                                    maxHeight={400}
                                    onColorSelect={handleColor}
                                    actions={
                                        <>
                                            <Button
                                                name="send"
                                                variant="contained"
                                                disabled={!isAuthorizedToSendCommand}
                                                onClick={handleCommandRow}
                                            >
                                                <Tooltip title="Enviar">
                                                    <ArrowForward/>
                                                </Tooltip>
                                            </Button>
                                            <></>
                                        </>
                                    }
                                /> || (
                                        <DataNotFound boxStyle={{height: 289, width: '100%'}}/>
                                    )
                        )
                        }

                    </ACard>
                </Grid>

                    {loadingStates.length > 0 && content != null && content.map(item => item)}
                </Grid>
            {selectedPowerPlant?.id && (
                <ActiveAlarms
                    powerPlantId={selectedPowerPlant.id}
                    equipmentId={equipmentId}
                    columnPreset="equipment-scoped"
                />
            )}
            {commandDTO != null && <ModalForSendingTelecommand commandDTO={commandDTO} open={open} onCloseModal={handleCloseModal}/>}
        </>
);
}

export default EquipmentDetailsSkid;
